import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Text } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import {
  scaleTime,
  scaleBar,
  Chart,
  Grid,
  LineChart,
  ScatterChart,
  XAxis,
  YAxis,
} from '@dbk/ui-charts';

import { PALETTE,NUMBER_SCALE } from '../../../../../../../src/constants';
import Interactions from './interactions';
import NoDataChart from '../../../../../../../src/components/common/no-data-chart';
import {
  getChartData,
  formatDateLabel,
  getXSmallTicks,
  getYAxisDomain,
  getYAxisDivisorIndex,
  getYAxisTitle,
  getYTickFormatter,
} from './utils';

import styles from './price-history-chart.styles';

const NUM_DAYS = 30;

class PriceHistoryChart extends PureComponent {
  static propTypes = {
    ...Chart.propTypes,
    data: PropTypes.arrayOf(PropTypes.object),
    currency: PropTypes.string,
    selectedInteractionValue: PropTypes.instanceOf(Date),
    onInteractionChange: PropTypes.func,
    screen: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      isSmall: PropTypes.bool,
    }).isRequired,
    yValue: PropTypes.string,
  };

  static defaultProps = {
    data: [],
    ratio: 2,
    margins: { left: 55, right: 0, top: 54, bottom: 30 },
    paddings: { left: 50, right: 20, top: 15, bottom: 10 },
    screen: {
      isSmall: false,
    },
  };

  getOuterComponents(data, chartData) {
    const {
      currency,
      selectedInteractionValue,
      onInteractionChange,
      margins,
      outerComponents,
    } = this.props;

    const noDataMarginTop = margins && margins.top ? margins.top * -1 : 0;
    const chartOuterComponents = data.length
      ? [<Interactions
        currency={currency}
        key="interactions"
        data={chartData}
        selectedValue={selectedInteractionValue}
        onChange={onInteractionChange}
      />]
      : [<NoDataChart
        key="no-data"
        marginTop={noDataMarginTop}
      />];

    if (outerComponents) {
      return [
        ...chartOuterComponents,
        ...outerComponents,
      ];
    }

    return chartOuterComponents;
  }



  getDivisor(value) {
    let chartValue;
    if(value<1){
     chartValue = value * -1;
    } else {
      chartValue = value;
    }
    const divisor = (div = 0) => {
      const newDiv = div + 1;
      const result = (chartValue / Math.pow(1000, newDiv));

      return result < 1 ? div : divisor(newDiv);
    };

    return value ? divisor() : 0;
  }


  getyAxisLabelText(item) {

    let scaleIndex;
    if(item === 0){
      scaleIndex = 0;
    } else {
      scaleIndex = this.getDivisor(item);
    }
    const scaleLabel = NUMBER_SCALE[scaleIndex] && this.props.messages[NUMBER_SCALE[scaleIndex]] ? `${this.props.messages[NUMBER_SCALE[scaleIndex]]}` : '';

    return scaleLabel;
  }






  render() {
    
    const {
      children,
      data,
      currency,
      height,
      width,
      margins,
      selectedInteractionValue,
      screen,
      yValue,
      messages,
      auth: {
        langCode
      }
    } = this.props;
    const ratio = height != null && width != null ? null : this.props.ratio;
    const validData = data.filter(({ price }) => price.value !== null);
   
    const yAxisDomain = getYAxisDomain(validData);
    const yAxisDivisorIndex = getYAxisDivisorIndex(yAxisDomain);
    const yTickFormatter = getYTickFormatter(yAxisDivisorIndex);
    const chartData = getChartData(validData, NUM_DAYS);
    const chartMargins = !!validData.length ? margins : { ...margins, left: 0 };
    const animated = selectedInteractionValue != null ? false : undefined;

    const yAxisLabelText = this.getyAxisLabelText(yAxisDomain[1]);


    //  if(chartData.length == 0) {
    //   return (<NoDataChart
    //     key="no-data"
    //   />);
    // }


    let yAxisLable=messages['app.common.portfolio.alter.mktPrice'];

    if(yValue!=undefined && yValue=="cash")
    {
      yAxisLable=messages['app.portfolio.dashboard.chartbalance'];
    }

    let chartWrapper = {};
    if (!screen.isSmall) {
      chartWrapper = {
        flex: 1,
        alignSelf: 'center',
        marginBottom: 10,
        // height: screen.height * 0.6,
        //width: screen.width * 0.5,
      };
    }

    return (
      <View style={chartWrapper}>
        {


          chartData.length > 1 &&
          <View>
            
            { yAxisLabelText!='' &&
              <Text style={styles.numberScale}>({yAxisLabelText})</Text>
            }
            
            <Chart
              axis={{
                x: {
                  accessor: row => row.x,
                  tickFormatter: date => formatDateLabel(date,langCode),
                  ticks: chartData => chartData,
                  //scale: scaleTime,
                  scale: scaleBar
                },
                y: {
                  tickFormatter: yTickFormatter,
                  domain: yAxisDomain,
                },
              }}
              animated={animated}
              {...this.props}
              outerComponents={this.getOuterComponents(validData, chartData)}
              data={chartData}
              margins={chartMargins}
              ratio={ratio}
              minWidth={80}
              minHeight={80}
            >
              <XAxis
                key="xaxis"
                styles={{
                  lineStyle: styles.yAxis,
                  tickStyle: styles.xAxisSmall,
                  tickLabelColor: styles.tickLabel.color,
                  tickLength: 2,
                }}
              />
              {!!validData.length && [
                <YAxis
                  labelText={yAxisLable}
                  position="middleText"
                  labelColor={styles.title.color}
                  labelHorizontalPadding={20}
                  showLine={false}
                  showTicks={false}
                  styles={{
                    tickLabelColor: styles.tickLabel.color,
                    
                  }}
                  isPriceHistChart = {true}
                  key="yaxis"
                />,
                <Grid key="grid" color={styles.grid.color} />,
                <LineChart key="line" color={PALETTE.lineChartColor} />,
                <ScatterChart key="scatter" color={PALETTE.lineChartColor} />,
              ]}
              {children}
            </Chart>
          </View>
        }
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      langCode: true
    },
  }
})(PriceHistoryChart);
